import styled from 'styled-components';

const Subtitle2 = styled.div`
  font-size: 16px;
  font-weight: normal;
  color: #232d3a;
`;

export default Subtitle2;
